<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" md="12" class="mt-3">
          <base-material-card color="primary" icon="mdi-order-alphabetical-ascending" inline class="px-5 py-3">
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">Descrição da UC</div>
            </template>
            <v-form class="pt-5">
              <v-row align="center" no-gutters class="ml-0">
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <v-textarea
                      v-model="codigos"
                      :error-messages="errors"
                      label="Códigos MCPSE"
                      placeholder="Insira os códigos MCPSE, um código por linha, seguindo o formato: TUC.A1.A2.A3.A4.A5.A6"
                      rows="5"
                      no-resize
                      clearable
                      clear-icon="mdi-close-circle"
                      autofocus
                      class="ml-4"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-form>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            :loading="loading"
            :disabled="invalid"
            style="float: right"
            color="success"
            min-width="100"
            class="ml-3 mt-2"
            @click="consultar()"
          >
            Consultar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>
  import DescricaoUcService from '@/services/DescricaoUcService.js';

  export default {
    name: 'DescricaoUc',

    data() {
      return {
        codigos: '',
        loading: false
      };
    },

    methods: {
      consultar() {
        this.loading = true;

        let data = [];
        data['codigos'] = this.codigos.split('\n');

        DescricaoUcService.consultarDescricoesUcs(data)
          .then(async (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'descricoes_ucs.xlsx');
            document.body.appendChild(link);
            link.click();
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao processar consulta.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>